import { useUser } from '@clerk/clerk-react';
import { Navigate } from 'react-router-dom';

const RequireAuth = ({ children }) => {
  const { isSignedIn, isLoaded } = useUser();

  if (!isLoaded) return null;
  if (!isSignedIn) return <Navigate to="/sign-in" />;

  return children;
};

export default RequireAuth;
